module.exports = __webpack_public_path__ + "img/rb@2x.339f3f93.png";